module.exports = __webpack_public_path__ + "img/man_shrugging.20cd10b2.gif";